import { default as COLORS } from '@/resources/style/Themes';
import { Badge, Box } from '@mui/material';
import lostConnectionIcon from '@/resources/images/location_notification.png';
import { useMapUiActions } from '@/stores/map/mapUiStore';

const DisconnectedUserButton = ({ numDisconnectedUsers }) => {
  const mapUiActions = useMapUiActions();

  return (
    <Badge
      badgeContent={numDisconnectedUsers}
      onClick={() => {
        mapUiActions.setShowLostConnectionListModal(true);
      }}
      color="error"
      overlap="circular"
      sx={{
        ':hover': {
          cursor: 'pointer',
          filter: 'brightness(0.9)',
        },
        width: '50px',
        height: '50px',
        alignSelf: 'end',
        '& .MuiBadge-badge': {
          backgroundColor: COLORS.RED,
          border: `2px solid ${COLORS.BORDER_RED}`,
          width: '20px',
          height: '20px',
        },
      }}
    >
      <Box
        sx={{
          width: '50px',
          height: '50px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundImage: `url(${lostConnectionIcon})`,
          backgroundSize: 'cover',
        }}
      ></Box>
    </Badge>
  );
};

export default DisconnectedUserButton;
